import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import MalwareChart from "../../../Components/common/MalwareChart/MalwareChart";

import CleanSubmissionsIcon from "../../../Components/Icon-SVG/CleanSubmissionsIcon";
import SuspiciousStatesIcon from "../../../Components/Icon-SVG/SuspiciousStatesIcon";
import MaliciousSubmissionsIcon from "../../../Components/Icon-SVG/MaliciousSubmissionsIcon";

import { RequestHunterBoxStats } from "../../../store/actions/integrationsActions";
import Stats from "./Stats";

const calculatePrct = (count, totalCount) => (count > 0 ? (count / totalCount) * 100 : 0);

const Distribution = () => {
  const dispatch = useDispatch();

  const cleanCount = useSelector((state) => state.integrations.hunterBoxStatistics.cleanCount);
  const suspiciousCount = useSelector(
    (state) => state.integrations.hunterBoxStatistics.suspiciousCount,
  );
  const maliciousCount = useSelector(
    (state) => state.integrations.hunterBoxStatistics.maliciousCount,
  );
  const agentCount = useSelector((state) => state.integrations.hunterBoxStatistics.agentCount);
  const uiCount = useSelector((state) => state.integrations.hunterBoxStatistics.uiCount);
  const publicApiCount = useSelector(
    (state) => state.integrations.hunterBoxStatistics.publicApiCount,
  );
  const totalCount = useSelector((state) => state.integrations.hunterBoxStatistics.totalCount);

  useEffect(() => {
    const fetchData = () => {
      dispatch(RequestHunterBoxStats());
    };

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  return (
    <>
      <div className="hunterbox__distribution border">
        <MalwareChart
          chartIcon={<CleanSubmissionsIcon width={32} height={32} />}
          chartValue={calculatePrct(cleanCount, totalCount)?.toFixed(2)}
          chartName="Clean Submissions"
          chartColor="#28c30f"
          chartCount={cleanCount}
        />
        <MalwareChart
          chartIcon={<SuspiciousStatesIcon width={32} height={32} />}
          chartValue={calculatePrct(suspiciousCount, totalCount)?.toFixed(2)}
          chartName="Suspicious Submissions"
          chartColor="var(--network-blocks-snort-url-border)"
          chartCount={suspiciousCount}
        />
        <MalwareChart
          chartIcon={<MaliciousSubmissionsIcon width={32} height={32} />}
          chartValue={calculatePrct(maliciousCount, totalCount)?.toFixed(2)}
          chartName="Malicious Submissions"
          chartColor="var(--network-blocks-sbox-border)"
          chartCount={maliciousCount}
        />
      </div>
      <Stats
        items={[
          {
            displayName: "agent",
            count: agentCount,
            percentage: calculatePrct(agentCount, totalCount).toFixed(0),
          },
          {
            displayName: "ui",
            count: uiCount,
            percentage: calculatePrct(uiCount, totalCount).toFixed(0),
          },
          {
            displayName: "public api",
            count: publicApiCount,
            percentage: calculatePrct(publicApiCount, totalCount).toFixed(0),
          },
        ]}
      />
    </>
  );
};

export default Distribution;
